// WorkspaceShell.js — the shared quote-workspace LAYOUT shell (shared-shell §3).
//
// This realizes Shaun's "extract a shared shell" decision WITHOUT touching
// business logic. The shell owns LAYOUT ONLY; each page owns everything else
// and passes it in as already-rendered nodes + plain data:
//   - header  : a <QuoteHeader> the page built from its own state
//   - sections: [{id,label,value,ts,status}] the page derived from its state
//   - activeId / onSelect : the page's focusedSection state (so ?section= deep
//                           linking and per-type defaults stay page-owned)
//   - rail    : <LiveTotalCard/> + <RailCard/>s the page built from its result
//   - children: the focus pane for the active section, rendered by the page
//
// It holds NO business state and owns NO handlers. Renders only: the header
// above the three-pane grid (260 · 1fr · 320, 24px gaps, page padding), the
// sticky SectionNav (left), the children (center), and the sticky rail (right).
import React from 'react';
import { v3 } from '../../lib/styleTokens';
import { SectionNav } from './SectionNav';

export function WorkspaceShell({
  header,
  sections = [],
  activeId,
  onSelect,
  navTitle,
  rail,
  children,
  style = {},
}) {
  return (
    <div style={{ fontFamily: v3.font.family, background: v3.color.bg, minHeight: '100%', ...style }}>
      {header}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: v3.layout.grid,
          gap: v3.layout.paneGap,
          padding: v3.layout.pagePadding,
          alignItems: 'start',
        }}
      >
        {/* Left — sticky section nav (SectionNav is sticky internally) */}
        <SectionNav sections={sections} activeId={activeId} onSelect={onSelect} title={navTitle} />

        {/* Center — the page's focus pane for the active section */}
        <div style={{ minWidth: 0 }}>{children}</div>

        {/* Right — the page's live total + rail cards, made sticky */}
        <aside
          style={{
            position: 'sticky',
            top: v3.layout.pagePadding,
            alignSelf: 'start',
            display: 'grid',
            gap: v3.layout.paneGap,
          }}
        >
          {rail}
        </aside>
      </div>
    </div>
  );
}
